"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var style_module_scss_1 = __importDefault(require("./style.module.scss"));
var mack_component_library_1 = require("mack-component-library");
var CustomTruckSection_1 = __importDefault(require("./CustomTruckSection"));
var CuratedChoicesTpl = function (_a) {
    var title = _a.title, body = _a.body, sectionTabs = _a.sectionTabs, heroImage = _a.heroImage, sections = _a.sections;
    var matchedDevice = (0, mack_component_library_1.useMediaQuery)().matchedDevice;
    var isMobile = matchedDevice.includes('mobile');
    var sectionRefs = (0, react_1.useRef)([]);
    var containerRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { ref: containerRef },
        react_1.default.createElement("div", { className: style_module_scss_1.default.container },
            react_1.default.createElement("div", { className: style_module_scss_1.default.overview },
                react_1.default.createElement("div", { className: style_module_scss_1.default.underline }),
                react_1.default.createElement(mack_component_library_1.Title, { as: isMobile ? 'h2' : 'h1' }, title),
                react_1.default.createElement(mack_component_library_1.RichText, { as: 'p', value: body })),
            react_1.default.createElement("div", { className: style_module_scss_1.default.tabsWrapper },
                react_1.default.createElement(mack_component_library_1.SectionTabs, { tabs: sectionTabs, className: style_module_scss_1.default.tabs, onSelected: function (key) {
                        var _a;
                        var index = sectionTabs.findIndex(function (s) { return s.value === key; });
                        if (!sectionRefs.current[index])
                            return;
                        (_a = sectionRefs.current[index]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
                    } })),
            react_1.default.createElement(mack_component_library_1.Image, { src: heroImage, className: style_module_scss_1.default.heroImage }),
            react_1.default.createElement("div", { className: style_module_scss_1.default.sections }, sections.map(function (section, index) {
                return (react_1.default.createElement(CustomTruckSection_1.default, { key: "section-slide-".concat(index), sectionRefs: sectionRefs, sections: section, index: index }));
            })))));
};
exports.default = CuratedChoicesTpl;
